<template>
  <div class="main-layout">
    <CCollapseItem>
      <template slot="title-left"> 测试结果管理</template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="批量通过" @click="passBach()">
            <i class="iconfont icon-pass" style="color: #2082f9"></i>
          </div>
          <div class="opt-btn" title="导出" @click="exportExcel">
            <i class="iconfont icon-daochu3" :class="{ disabled: isExport }"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>

      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
      >
        <template slot="status" slot-scope="scope">
          <span>{{ scope.row.statusName }}</span>
          <el-tag
            v-if="scope.row.isSelf == 0"
            size="mini"
            style="margin-left: 5px"
            title="后台批量通过，非学生本人操作"
            >批量通过
          </el-tag>
        </template>
        <template slot="custom" slot-scope="scope">
          <div class="contr-btn-group">
            <div class="contr-btn" title="详情" @click="gotoDetail(scope.row)">
              <div
                :class="{
                  'detail-disabled': scope.row.status == -1,
                }"
              >
                <img src="../../../../../assets/images/icon/detail.png" />
              </div>
            </div>
          </div>
        </template>
      </c-table>
    </el-card>
    <!-- 编辑弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            :formItems="formItems"
            @submit="submit"
            @resetFields="resetFields"
          >
          </c-form>
        </div>
      </div>
    </el-dialog>
    <!-- 添加导入弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="上传文件"
      :visible.sync="dialogVisible"
      @close="handleDialogClose"
      width="30%"
      custom-class="upload-dialog"
    >
      <div class="upload-container">
        <el-upload
          ref="upload"
          class="upload-box"
          drag
          :headers="importHeader"
          action="/account/base/student/importExcel"
          :http-request="customUpload"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div class="download-box">
          <el-button type="success" @click="handleDownloadTemp"
            >点击下载模板
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/result";
import { mapState } from "vuex";
import { getOrgOptions } from "@/libs/searchSelect";
let mPage = MPage({
  pagePath: "/welcome-forecast/test/listPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    academicDegree: "",
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
    classIdList: [],
  },
  pageExportPath: "/welcome-forecast/test/exportExcel",
  pageExportParams: {},
});
let mHandle = MHandle({
  handleGetPath: "/welcome-forecast/test",
  handleInsertPath: "/welcome-forecast/test/save",
  handleUpdatePath: "/welcome-forecast/test/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  name: "",
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      formItems,
      formRules,
      idList: [],
      studentIdList: [],
      title: "",
      dialogFormVisible: false,
      dialogType: "form",
      defaultHandleData: {
        id: "",
        name: "",
        lng: "",
        lat: "",
        address: "",
        location: "",
        description: "",
      },
      dialogVisible: false,
      importHeader: {},
      isExport: false, // 是否导出
    };
  },
  computed: {
    ...mapState("dic", ["_CURRENTYEAR", "_COLLEGE_ID", "_CURRENT_ACADEMIC"]),
  },
  created() {
    this.setCollegeId();
    let token = localStorage.getItem("token");
    this.importHeader = { token };
    this.handleData = Object.assign({}, this.defaultHandleData);
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    //批量通过
    passBach() {
      if (this.studentIdList.length > 0) {
        this.$confirm("此操作将批量通过所选学生入学测试，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }).then(() => {
          this.$http
            .post("/welcome-forecast/test/passBatch", this.studentIdList)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(res.msg);
                this.pageGet(true);
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        });
      } else {
        this.$message.warning("请选择需要批量通过的数据");
      }
    },
    gotoDetail(data) {
      // 批量通过和未测试的不可查看详情
      if (data.status == -1) return;
      this.$router.push(
        "/welcome/teacher/entranceTest/detail/" + data.studentId
      );
    },
    goto(data) {
      this.dialogFormVisible = true;
      this.handleData = Object.assign({}, this.defaultHandleData);
      let id = data.id;
      if (id) {
        this.handleGet(id);
        this.title = "详情";
      } else {
        this.title = "新增";
      }
    },
    selectionChange(data) {
      let idList = [];
      let studentIdList = [];
      this.idList = [];
      this.studentIdList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
          studentIdList.push(item.studentId);
        });
        this.idList = idList;
        this.studentIdList = studentIdList;
      }
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = Object.assign({}, this.pageParams);
        if (!params.academicDegree)
          params.academicDegree = this._CURRENT_ACADEMIC;
        params.enrollmentYear = this._CURRENTYEAR[0].value;
        this.pageExportParams = params;
        if (this.studentIdList.length) {
          this.pageExportParams.studentIds = this.studentIdList;
        }
        this.pageExportParams.classId = this.pageExportParams.classIdList.join();
        delete this.pageExportParams.classIdList;
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    pageGetBeforeFn(data) {
      let params = Object.assign({}, data);
      if (!params.academicDegree)
        params.academicDegree = this._CURRENT_ACADEMIC;
      params.enrollmentYear = this._CURRENTYEAR[0].value;
      params.classId = params.classIdList.join(",");
      delete params.classIdList;
      return params;
    },
    refresh() {
      this.searchItems[1].options = [];
      this.searchItems[2].options = [];
      this.pageParams = {
        academicDegree: "",
        collegeId: "",
        grade: "",
        majorId: "",
        classId: "",
        classIdList: [],
      };
      this.setCollegeId();
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleAfterFn() {
      this.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
      this.pageGet(true);
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
    handleDialogClose() {
      if (this.$refs.cForm) {
        this.$refs.cForm.resetFields();
      } else {
        this.$refs.upload.clearFiles();
      }
    },
    // 导入
    handleImport() {
      this.dialogVisible = true;
    },
    // 文件上传成功的回调
    uploadSuccess(msg, response, file, fileList) {
      this.$message.success(`导入数据成功！${msg}`);
      this.$refs.upload.clearFiles();
      this.dialogVisible = false;
      this.pageGet(true);
    },
    // 文件上传失败的回调
    uploadError(err, file, fileList) {
      // console.log(err);
      this.$message.error(`导入数据失败，${err}`);
    },
    // 自定义上传方法
    customUpload: function(e) {
      let that = this;
      let formData = new FormData();
      formData.append("file", e.file);
      this.$http
        .post(e.action, formData, {
          responseType: "blob",
        })
        .then((res) => {
          // console.log(res);
          if (res.type == "application/json") {
            let reader = new FileReader();
            reader.readAsText(res, "utf-8");
            reader.onload = function() {
              let resu = JSON.parse(reader.result);
              // console.log("resu:", resu);
              if (resu.code == that.SUCCESS_CODE) {
                that.uploadSuccess(resu.data);
              } else {
                that.uploadError();
              }
            };
          } else {
            that.uploadError("导入失败");
            let link = document.createElement("a"); // 创建下载链接
            link.download = "错误数据.xlsx"; //设置下载的名称
            link.style.display = "none"; // 隐藏的可下载链接
            link.href = URL.createObjectURL(res);
            // 绑定点击时间
            document.body.appendChild(link);
            link.click();
            // 然后移除
            document.body.removeChild(link);
          }
        });
      // console.log(e);
    },
    // 下载导入模板
    handleDownloadTemp() {
      window.location.href = this.$store.state.dic.STUDENT_BASE_TEMPLATE;
    },
  },
};
</script>
